import { Dic, Dates } from '$utils'
const table = function (that) {
  return {
    maxHeight: '100%',
    page: true,
    editBtn: false,
    delBtn: false,
    header: false,
    menu: true,
    view:"详情",
    stripe: true,
    emptyText: that.$t('taskCenter.label.noData'),
    menuAlign: 'center',
    menuWidth: 150,
    viewFormSlot: true,
    index: true,
    // selection: true,
    indexLabel: that.$t('taskCenter.label.no'), //this.$t('taskCenter.label.count'),'序号1',
    column: [
      {
        label: "备份名称",
        prop: 'backupName',
        search: true,
      
      },
      {
        label: "备份类型",
        prop: 'type',
        type:'select',
        search: true,
        align: 'center',
        width: 120,
        dicData: Dic.find('SENU107001'),
        formatter: function (row, value) {
          return Dic.findByValue('SENU107001', value)
        },
        viewFormatter: function (row, value) {
          return Dic.findByValue('SENU107001', value)
        },
      },
      {
        label: "备份状态",
        prop: 'status',
        type:'select',
        align: 'center',
        width: 120,
        dicData: Dic.find('SENU107002'),
        formatter: function (row, value) {
          return Dic.findByValue('SENU107002', value)
        },
        viewFormatter: function (row, value) {
          return Dic.findByValue('SENU107002', value)
        },
      },
      {
        label:"备份时间",
        prop: 'backupTime',
        search: true,
        hide: true,
        type: 'datetimerange',
        align: 'center',
        viewDisplay: false,
        valueFormat: 'timestamp',
      },
      {
        label:"备份文件",
        prop: 'dataFile',
        align: 'center',
        hide: true,
        viewDisplay: true,
        span:24
      },
      {
        label:"备份创建时间",
        prop: 'createTime',
        align: 'center',
        viewDisplay: true,
        span:12
      },
      {
        label:"备份开始时间",
        prop: 'beginTime',
        align: 'center',
        viewDisplay: true,
        span:12
      },
      {
        label:"备份结束时间",
        prop: 'endTime',
        align: 'center',
        viewDisplay: true,
        span:12
      },
     
    ]
  }
}



export { table }
